import { BaseComponent } from "../base-component.js";
import componentStyles from './page-404.css?inline';

export class Page404 extends BaseComponent {

  protected styles(): string {
    return componentStyles;
  }

  protected template(): string {
    return `
      <ag-panel>
        <ag-panel-header>
          <h1>404: Page Not Found</h1>
        </ag-panel-header>
        <ag-panel-content>
          <p>The page you're looking for doesn't seem to exist.</p>
          <a href="/" class="home-link">Go Home</a>
        </ag-panel-content>
      </ag-panel>
    `;
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.render();
  }
}

customElements.define('page-404', Page404);